import {PollPublishType} from "@irati/types"
export const PUBLISH_CUSTOMIZATION_PROPERTY = "publishType"

export const DEFAULT_OPTION = PollPublishType.PublishTypeAutomatic

export const AUTO_OPTION = (formatMessage) => ({
  label: formatMessage({id: "platform.fields.poll.publish.option.auto"}),
  name: formatMessage({id: "platform.fields.poll.publish.option.auto"}),
  value: PollPublishType.PublishTypeAutomatic
})

export const MANUAL_OPTION = (formatMessage) => ({
  label: formatMessage({id: "platform.fields.poll.publish.option.manual"}),
  name: formatMessage({id: "platform.fields.poll.publish.option.manual"}),
  value: PollPublishType.PublishTypeManual
})

export const DEFAULT_OPTIONS = (formatMessage) => [AUTO_OPTION(formatMessage), MANUAL_OPTION(formatMessage)]
